/**
 * 常用函数库插件
 */
var Library = {};
Library.install = function (Vue, options) {
    // 1. 添加全局方法或属性
    Vue.$et = function () {
        // 逻辑..
    },
    // 2. 添加全局资源
    Vue.directive('my-direive', {
        bind (el, binding, vnode, oldVnode) {
        // 逻辑...
        }
    }),
    // 3. 注入组件
    Vue.mixin({
        created: function () {

        },
        methods: {
            // $getAccessToken: function(){
            //     return  window.sessionStorage.getItem('accessToken');
            // },
            // $getUserInfo: function(){
            //     return  JSON.parse(sessionStorage.getItem('userInfo'));
            // },
        }
    })

    // 对Date的扩展，将 Date 转化为指定格式的String
    // 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
    Vue.prototype.formatDate = function(time,format) {
        if(parseInt(time) == 0 || isNaN(parseInt(time))){
           return '';
        }
        var times = new Date(parseInt(time + '000'));
        var year = times.getFullYear().toString(); 
        var month = times.getMonth()+1; 
        var day = times.getDate(); 
        var hour = times.getHours(); 
        var minute = times.getMinutes(); 
        var second = times.getSeconds(); 
        var o = {   
            "M+" : month,                 //月份   
            "d+" : day,                    //日   
            "h+" : hour,                   //小时   
            "m+" : minute,                 //分   
            "s+" : second                //秒   
            // "q+" : Math.floor((date.getMonth()+3)/3), //季度   
            // "S"  : date.getMilliseconds()             //毫秒   
          };   
        if(/(y+)/.test(format)) { 
           format=format.replace(RegExp.$1, year.substr(4 - RegExp.$1.length));  
        } 
        for(var k in o)   
        if(new RegExp("("+ k +")").test(format)){  
            format = format.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length))); 
        }  
        return format;
    },
    // 4. 添加事例方法
    //数字转成汉字对应
    Vue.prototype.$numberToChina = function (num) {
        var china = "零,一,二,三,四,五,六,七,八,九,十";
        var chinaArray = china.split(',');
        return chinaArray[num];
    },
    //一维数组去重
    Vue.prototype.$arrayUnique = function(arr) {
        var result = [], hash = {};
        for (var i = 0, elem; (elem = arr[i]) != null; i++) {
            if (!hash[elem]) {
                result.push(elem);
                hash[elem] = true;
            }
        }
        return result;            
    },
            //在url中添加参数
    Vue.prototype.$setUrlParam = function(url, param, value){
        var uri = url.split('?');
        (uri.length != 2) ? query = '' : query = uri[1];
        var host = uri[0];
        var p = new RegExp("(^|&"+param+")=[^&]*");
        if(p.test(query)){
            query = query.replace(p,"$1="+value);
            host  =  host + '?'+query;
        }else{
            if(query == ''){
                host = host + '?'+param+'='+value;
            }else{
                host  = host + '?'+query+'&'+param+'='+value;
            }
        }  
        return host;  
    },
    //获取url参数
    Vue.prototype.$getUrlParam = function (param) { 
        var reg = new RegExp('(^|&)' + param + '=([^&]*)(&|$)', 'i');
        var r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    },
    Vue.prototype.$parseURL =  function(url) {  
        var a =  document.createElement('a');  
        a.href = url;  
        return {  
            source: url,  
            protocol: a.protocol.replace(':',''),  
            host: a.hostname,  
            port: a.port,  
            query: a.search,  
            params: (function(){  
             var ret = {},  
                 seg = a.search.replace(/^\?/,'').split('&'),  
                 len = seg.length, i = 0, s;  
             for (;i<len;i++) {  
                 if (!seg[i]) { continue; }  
                 s = seg[i].split('=');  
                 ret[s[0]] = s[1];  
             }  
            }),
            file: (a.pathname.match(/\/([^\/?#]+)$/i) || [,''])[1],
            hash: a.hash.replace('#',''),
            path: a.pathname.replace(/^([^\/])/,'/$1'),
            relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [,''])[1],
            segments: a.pathname.replace(/^\//,'').split('/')
        }
    },
    //滚动条在y轴上的滚动距离
    Vue.prototype.$getScrollTop = function(){
　　    var scrollTop = 0, bodyScrollTop = 0, documentScrollTop = 0;
　　    if(document.body){
    　　　　bodyScrollTop = document.body.scrollTop;
    　　}
    　　if(document.documentElement){
            documentScrollTop = document.documentElement.scrollTop;
        }
        scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
        return scrollTop;
    },
    //获取文档的总高度
    Vue.prototype.$getScrollHeight = function(){
        var scrollHeight = 0, bodyScrollHeight = 0, documentScrollHeight = 0;
        if(document.body){
            bodyScrollHeight = document.body.scrollHeight;
        }
        if(document.documentElement){
            documentScrollHeight = document.documentElement.scrollHeight;
        }
        scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
        return scrollHeight;
    },
    
    //浏览器窗口的高度
    Vue.prototype.$getWindowHeight = function(){
        var windowHeight = 0;
        if(document.compatMode == "CSS1Compat"){
            windowHeight = document.documentElement.clientHeight;
        }else{
            windowHeight = document.body.clientHeight;
        }
        return windowHeight;
    },

    //判断对象是否为空
    Vue.prototype.$empty = function (value){
        var type;
        if(value == null || value == 0) { // 等同于 value === undefined || value === null
            return true;
        }
        type = Object.prototype.toString.call(value).slice(8, -1);
        switch(type){
            case 'String':
                if(value.trim().length == 0){
                    return true; 
                }
            case 'Array':
                return !value.length;
            case 'Object':
                if(JSON.stringify(value) == "{}"){
                    return true;
                }
                for(var k in value){
                    return false;
                } 
            default:
                return false; // 其他对象均视作非空
        }

    },
    /**
     * 递归遍历数据
     */
    Vue.prototype.$treeToList = function (arr,list){
        
        var list = list || [];
        var i= 0,len=arr.length;
        for( ; i<len; i++){
            list.push(arr[i])
            if(arr[i].children && arr[i].children.length > 0){
                this.$treeToList(arr[i].children, list);
            }
        }
        return list;
    }
    /**
     * 递归遍历数据
     */
    Vue.prototype.$treeMenu = function (arr,list, level){
        
        var list = list || [];
        var i= 0,len=arr.length;
        var level = level || '';
        for( ; i<len; i++){
            arr[i].name = level + arr[i].name
            list.push(arr[i])
            if(arr[i].children && arr[i].children.length > 0){
                this.$treeMenu(arr[i].children, list, level + '—');
            }
        }
        return list;
    }
    /**
     * 递归遍历数据
     */
    Vue.prototype.$inArray = function (arr, value){
        var i = arr.length;  
        while(i--){  
            if (arr[i] == value) {  
                return true;  
            }  
        }  
        return false;  
    },
    /**
     * 合并对象，也可以合并空对象用以达到“解除”指针引用关系的目的，达到深复制。
     * 也可以用es6的  object.assign，一般使用assign方法需要用一个空对象接受，因为会影响到第一个参数
     */
    Vue.prototype.$extend = function(obj1,obj2){
        for(let key in obj2) {            
            obj1[key] = obj1[key] && obj1[key].toString() === "[object Object]" ?
            this.$extend(obj1[key], obj2[key]) : obj1[key] = obj2[key];
        }
        return obj1;
    }
    /**
     * 判断对象是否为字符串
     */ 
    Vue.prototype.$isString = function(obj){
        return Object.prototype.toString.call(obj)=="[object String]";
    },
    /**
     * 数字转中文
     */
    Vue.prototype.$numberToChina = function(num){
        var china = "零,一,二,三,四,五,六,七,八,九,十";
        var chinaArray = china.split(',');
        return chinaArray[num];
    },
    /**
     * 数组diff a - b
     */
    Vue.prototype.$arrayDiff = function(a,b) {
        return a.filter(function(i) {return b.indexOf(i) < 0;});  
    },
    Vue.prototype.$goToBack = function (uri) {
            this.$router.go(-1)
    },
    /**
     * 路由跳转
     */
    Vue.prototype.$goToPath = function(path) {
        this.$router.push(path);
    },
    //用户角色
    Vue.prototype.$getUserRole = function()
    {
        let role = [
            { id: 10, name: '博物馆'},
            { id: 20, name: '设计师'},
            { id: 30, name: '衍生品生产商'},
            { id: 40, name: '作品提供商'}
        ];
        return role;
    }
}
export default Library;
//module.exports = Library;


// WEBPACK FOOTER //
// ./src/utils/library.js